import { useEffect, useState } from "react";
import { Layout } from "../layout";
import { WegetCardList } from "./wegets/weget-card-list";
import styled from 'styled-components';
import { useFetcher } from "./fetcher/useFetcher";
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContext";

const StyledContainer = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        fetcher.fetchReturnExchangeArchives();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
    ])

    return (
        <>
            <Layout>
                <StyledContainer>
                    <WegetCardList />
                </StyledContainer>
            </Layout>
        </>
    );
}